/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { Breadcrumbs, Typography } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { FC } from "react";
import { theme } from "theme";

interface Props {
  /** Phase title list */
  titles: string[];
  /** Current phase number */
  phase: number;
}

/**
 * Component of phase indicator on the panel header
 * @param {Props} param0 Properties
 * @return {ReactNode} Component
 */
export const PhaseIndicator: FC<Props> = ({ titles, phase }: Props) => {
  return (
    <Breadcrumbs separator={<ArrowForwardIosIcon />} aria-label="breadcrumb">
      {titles.map((t, i) => {
        return (
          <Typography
            key={`breadcrumb-${i}`}
            variant="subtitle1"
            color={getColor(i, phase)}
          >
            {t}
          </Typography>
        );
      })}
    </Breadcrumbs>
  );
};

/**
 * Get color of title
 * @param{number} phaseIndex Index of phase
 * @param{number} currentPhase Current phase number
 * @return{string} Color
 */
const getColor = (phaseIndex: number, currentPhase: number) => {
  if (phaseIndex < currentPhase) {
    // Before current phase
    return theme.palette.text.primary;
  } else if (phaseIndex > currentPhase) {
    // After current phase
    return theme.palette.text.disabled;
  }
  // Current phase
  return theme.palette.primary.light;
};
